module.exports = __webpack_public_path__ + "card2-v1.dea935fd7aadfcf45f9015c5855926e9.jpg";